export default {
  menu: {
    dashboard: 'Dashboard',
    invoices: 'Invoices',
    transactions: 'Transactions',
    payments: 'Payments',
    analytics: 'Analytics',
    remittance: 'Remittances',
    buyers: 'Buyers',
    account: 'Your Account',
    currencySettings: 'Currency settings',
    bankAccounts: 'Bank Accounts',
    support: 'Support',
    createInvoice: 'Add New Invoice',
    activity: 'Activity',
    passbook: 'Passbook',
    accountSummary: 'Account Summary',
    dripOne: 'Insights',
    resources: 'Resources',
    new: 'New',
    masterBL: 'Master BL List',
    holiday: 'Bank Holiday List',
    chargesCalculator: 'Charges Calculator',
    checkLimitsHere: 'Check Limits',
    cmaList: 'CMA List',
    signOut: 'Signout'
  },
  dashboard: {
    htmlTitle: 'Dashboard | Drip Portal',
    title: 'Dashboard',
    addInvoiceBtn: 'Add Invoice',
    offlineBanner: {
      in: {
        title: 'Our company will have a holiday on 17th June, Monday for Eid!',
        text: "We won't be able to respond to emails, portal inquiries, or process any funding. The team and system will be back online on Tuesday, 18th June.",
        writtenBy: ' - Team Drip Capital'
      }
    },
    quickGlance: {
      pending: {
        type: 'Pending',
        text: 'Invoices'
      },
      outstanding: {
        type: 'Outstanding',
        text: 'Invoices'
      },
      collections: {
        type: 'Due',
        text: 'Invoices'
      },
      settled: {
        type: 'Settled',
        text: 'Invoices'
      },
      helpTexts: {
        advancePending: 'Advance pending invoices',
        invoiceAdvanced: 'Invoices advanced',
        settlementsPending: 'Settlement pending invoices'
      },
      viewInvoices: 'View invoices'
    },
    accountNumbers: {
      title: 'Drip Account',
      totalLimitLabel: 'Total Facility Limit',
      progressLabel: 'Used Facility Limit',
      ddpProgressLabel: 'Dynamic Drawing Power',
      outstandingLabel: 'Charges Outstanding',
      settlementLabel: 'Settlement Outstanding',
      increaseLimit: 'Increase my limit →',
      requestModal: {
        loading: 'Loading...',
        ok: 'OK',
        successMessage:
          'Thank you for submitting this request. You will receive an email shortly acknowledging your request and a link where you can follow the status of your ticket.'
      }
    },
    pricingDetails: {
      title:
        'There has been an update to your pricing terms. These terms are applicable as of ',
      desc: 'Your revised discount rate is',
      effective: 'effective',
      link: 'Please click here to review your pricing details',
      modalTitle: 'Pricing details'
    },
    enableDripSwitchModal: {
      title:
        'Do you want to enable INR transactions for {invoice_number} invoice?',
      description: 'You can control the same while submitting an invoice.',
      alternateDescription:
        'You can control the INR payments through currency settings page.',
      confirm: 'Yes, enable',
      disableINR: 'Disable INR payments',
      cancel: 'Cancel',
      successMessage: {
        title: 'Your INR payments have been enabled for this invoice',
        body: 'Your INR Payments has been enabled successfully'
      },
      selectAnOption: 'Kindly Select an option',
      optionHeading:
        'Please select from the following options for enabling INR payments:',
      enableAll: 'Enable for all invoices',
      enableInvoice: 'Enable for this invoice only'
    },
    requestCallbackWidget: {
      header: {
        prepend: 'We can beat your',
        append: 'bank rate!'
      },
      subHeader:
        'Share an older foreign exchange advice and Drip will beat the rate.',
      description: 'Contact your Account Manager',
      buttonText: 'Request a callback',
      successMessage:
        'Request Received. Our Account Manager will reach out to you shortly.',
      errorMessage: 'Something went wrong!'
    },
    requestCallbackWidgetAdvPO: {
      header: 'Drip Capital Now Introduces',
      title: {
        line1: 'Advance against',
        line2: 'Purchase Order'
      },
      additionalNote: {
        line1: 'To know more, contact your',
        line2: 'Account Manager OR'
      },
      buttonText: 'Request a Callback',
      successMessage:
        'Request Received. Our Account Manager will reach out to you shortly.',
      errorMessage: 'Something went wrong!'
    },
    disableDripSwitchSidebar: {
      title:
        'Are you sure you want to disable INR payments? Please share your reason for the same.',
      subTitle:
        'This will help us understand your currency preferences and how we can serve you better.',
      alternateTitle:
        'We understand your preference of not receiving INR payments.',
      alternateSubTitle:
        'Kindly provide us with the reason for the same. This will help us understand your currency preferences and we can serve you better.',
      error: {
        title: 'Select options before submitting'
      },
      successMessage: {
        title: 'Your INR payments have been disabled for this invoice.',
        body: 'Your INR payments have been disabled for this invoice'
      },
      options: [
        {
          text: 'I have a foreign currency packing credit with my bank',
          value: 'I have a foreign currency packing credit with my bank'
        },
        {
          text: 'I have already hedged / booked a rate for expected USD payments',
          value:
            'I have already hedged / booked a rate for expected USD payments'
        },
        {
          text: 'I am not sure if the rate I receive from Drip will be better than my bank',
          value:
            'I am not sure if the rate I receive from Drip will be better than my bank'
        },
        {
          text: 'I am interested but I have more questions',
          value: 'I am interested but I have more questions'
        },
        {
          text: 'I am not sure if my bank will be okay with this',
          value: 'I am not sure if my bank will be okay with this'
        },
        { text: 'I have already opted in', value: 'I have already opted in' },
        { text: 'Other', value: 'Other' }
      ],
      alternateConfirmBtn: 'Submit reason(s)'
    },
    pendingInvoicesWidget: {
      title: 'Invoices Pending Advance',
      viewAll: 'View All Pending Invoices →',
      table: {
        reference: 'Reference',
        importer: 'Importer',
        value: 'Invoice Value',
        status: 'Status',
        actions: 'Actions'
      },
      view: 'View →',
      edit: 'Edit →',
      editText: 'Edit',
      noPending: 'You do not have any pending invoices. Click',
      here: 'here',
      addNew: 'to add a new invoice.',
      invoiceTableFields: [
        {
          key: 'reference',
          label: 'Ref. No.'
        },
        {
          key: 'importer',
          label: 'Importer'
        },
        {
          key: 'value',
          label: 'Invoice Value'
        },
        {
          key: 'stage_human',
          label: 'Status'
        },
        {
          key: 'actions',
          label: 'Actions'
        }
      ],
      status: {
        'Docs Pending': 'Docs Pending',
        'Exporter E-Sign Pending': 'Esign Required',
        'Exporter E-Sign Generated': 'Esign Required',
        'Invoice Processing': 'Processing',
        'Basic Info Pending': 'Basic Info Pending',
        Draft: 'Draft',
        'Buyer E-Sign Pending': 'Buyer E-Sign Pending',
        Hold: 'Hold',
        Pending: 'Pending',
        Processing: 'Processing',
        Approved: 'Approved',
        Advanced: 'Advanced',
        Paid: 'Paid',
        Settled: 'Settled',
        'Partial Advanced': 'Partial Advanced',
        'Partial Payment': 'Partial Payment',
        'Pending Settlement': 'Pending Settlement',
        'Auto Advanced': 'Auto Advanced',
        NPA: 'NPA',
        Claim: 'Claim',
        Outdated: 'Outdated',
        'Auto Settled': 'Auto Settled',
        Overdue: 'Overdue',
        'Follow Up': 'Follow Up',
        Revised: 'Revised',
        'Revision Pending': 'Revision Pending',
        'Review and Submit': 'Review Pending',
        'E-Sign Pending': 'E-Sign Pending',
        'Physical Docs Pending': 'Processing'
      }
    },
    globalCurrencySettingsWidget: {
      title: 'Remittance Currency',
      description:
        'You will receive all remittances for USD invoices from Drip Capital in INR.',
      currencySettingsDescription:
        'Go to Currency Settings to change your preferences.',
      currencySettings: 'Currency Settings',
      enabled: 'INR remittances enabled',
      usdInvoice: 'For USD invoices only'
    },
    conversionRateDetailsWidget: {
      title: 'Save more through payments in INR!',
      subTitle: 'And secure your eBRC hassle free!',
      enableINRButtonText: 'Enable INR payments',
      knowMoreButtonText: 'Know more',
      steps: {},
      remittanceAmount: 'You receive an INR remittance of',
      getMyFunds: 'Get my funds in INR',
      transactionAmount: 'Transaction Amount',
      conversionRate: 'Best forex Conversion Rate',
      zeroAddedFess: 'Zero Added Fees',
      rateConversionRateFail: 'Rate Currently Unavailable'
    },
    alternateConversionRateDetailsWidget: {
      title: 'Save more through payments in INR!',
      subTitle: 'And secure your eBRC hassle free!',
      enableINRButtonText: 'Enable INR payments'
    },
    secondAlternateConversionRateDetailsWidget: {
      title: 'Save more by getting payments in INR!',
      subTitle: 'And secure your eBRC hassle free!',
      confirmationTitle:
        'Do you want to enable INR transactions for all your invoices?',
      confirmationSubtitle:
        'You will receive all USD remittances from Drip Capital in INR',
      yesEnableButtonText: 'Yes, Enable',
      cancel: 'Cancel',
      enableINRButtonText: 'Enable INR payments'
    },
    congratulationText: {
      title: 'Congratulations!',
      subtitle: {
        prepend:
          'You will now receive all USD remittances from Drip Capital in INR.',
        append: 'This will maximise your savings without any transaction fee.'
      },
      addInvoiceText: 'Add new invoice',
      backToDashboardText: 'Back to Dashboard',
      gotItText: 'Got it',
      continueSubmitting: 'Continue submitting'
    },
    alternateCongratulationText: {
      title: 'Congratulations!',
      subtitle: {
        prepend:
          'You will now receive USD remittances for this invoice from Drip Capital in INR.',
        append: 'This will maximise your savings without any transaction fee.'
      },
      addInvoiceText: 'Add new invoice',
      backToDashboardText: 'Back to Dashboard',
      gotItText: 'Got it'
    },
    InrRemittanceDetails: {
      inrRemittance: 'We have switched you to Indian Rupee (INR) remittances.',
      nostroAccounts:
        'No need to worry about remittances stuck in NOSTRO accounts',
      receiveRemittances:
        'Receive remittances in your INR account within 24 working hours of disbursement.',
      buttonTitle: 'Don’t want to receive remittances in INR?',
      buttonLabel: 'Disable INR remittances'
    },

    advanceInvoicesWidget: {
      title: 'Advanced Invoices',
      invoiceTableFields: [
        {
          key: 'date',
          label: 'Date'
        },
        {
          key: 'reference',
          label: 'Invoice Ref.'
        },
        {
          key: 'importer',
          label: 'Importer'
        },
        {
          key: 'type',
          label: 'Type'
        },
        {
          key: 'value',
          label: 'Value'
        },
        {
          key: 'action',
          label: 'Actions'
        }
      ],
      noRecentTransactions:
        'You do not have any recent transactions. Check back in a few days once you have some processed invoices.',
      status: {
        advance: 'Advance',
        payment: 'Payment',
        settlement: 'Settlement'
      },
      viewAll: 'View Advanced Invoices →',
      table: {
        reference: 'Reference',
        importer: 'Importer',
        value: 'Invoice Value',
        status: 'Status',
        actions: 'Actions'
      }
    },
    transactionsWidget: {
      title: 'Recent Transactions',
      viewAll: 'View All Transactions →',
      table: {
        reference: 'Reference',
        importer: 'Importer',
        value: 'Invoice Value',
        status: 'Status',
        actions: 'Actions'
      },
      noRecentTransactions:
        'You do not have any recent transactions. Check back in a few days once you have some processed invoices.',
      invoiceTableFields: [
        {
          key: 'date',
          label: 'Date'
        },
        {
          key: 'reference',
          label: 'Invoice Ref.'
        },
        {
          key: 'importer',
          label: 'Importer'
        },
        {
          key: 'type',
          label: 'Type'
        },
        {
          key: 'value',
          label: 'Value'
        },
        {
          key: 'action',
          label: 'Actions'
        }
      ],
      status: {
        advance: 'Advance',
        payment: 'Payment',
        settlement: 'Settlement'
      }
    },
    conversionRate: {
      heading: 'Currency Conversion',
      usd: '$',
      inr: '₹',
      oneUSD: '1 USD',
      note: 'Conversion rates will vary based on the time of actual payment release.',
      chip: 'INR Payments Enabled',
      conversionRateFailed: 'Currently unavailable'
    },
    promos: {
      comingSoon: 'Shipment Tracking coming soon...',
      track: 'Track your Shipment',
      analytics: {
        title: 'Grow your business',
        desc: 'Analytics to help you grow your business coming soon to Drip Capital.'
      },
      app: {
        title: 'E-sign your invoices on the go!',
        subtitle:
          'Now you can e-sign your invoices with the Drip Capital App for instant funding.',
        links: [
          {
            icon: 'playstore.svg',
            title: 'Download from Google Play',
            link: 'https://play.google.com/store/apps/details?id=com.dripcapital.portal'
          },
          {
            icon: 'app-store.svg',
            title: 'Download from App Store',
            link: 'https://apps.apple.com/us/app/drip-capital/id1538574258'
          }
        ]
      }
    },
    financialsWidget: {
      title: 'Your financials for FY’22 are missing',
      description:
        'To maintain an Active Status and ensure future funding, please share your FY’22 audited financials or ITR (in case of a proprietorship firm) before March 31, 2023.',
      disclaimer: 'PS. - please ignore if already shared.',
      emailInstruction: 'Email address for sending financials',
      emailCopiedMessage: 'Email address copied successfully'
    },
    openInvoiceCard: {
      title: 'Newly launched',
      subtitle:
        'Manage your open invoices and enable payments in INR to save more!',
      invoicesCount: {
        amend: 'out of',
        append: 'invoices',
        subtitle: 'Are set for INR payments'
      },
      button: 'Currency settings'
    },
    manageAndCoversion: {
      manageTitle:
        'Manage your open invoices and enable payments in INR to save more!',
      saveMoreTitle:
        'Save more through payments in INR and secure your eBRC hassle free'
    }
  },
  comingSoon: 'Coming Soon...',
  transactions: {
    index: {
      htmlTitle: 'Transactions | Drip Portal',
      title: 'Transactions',
      fields: {
        advances: [
          {
            key: 'disbursed',
            label: 'Disbursement Date'
          },
          {
            key: 'invoice_reference',
            label: 'Invoice Reference'
          },
          {
            key: 'invoice_importer',
            label: 'Importer'
          },
          {
            key: 'customer_bank',
            label: 'Remittance Bank'
          },
          {
            key: 'value',
            label: 'Value'
          },
          {
            key: 'action',
            label: 'Actions'
          }
        ],
        payments: [
          {
            key: 'dated',
            label: 'Payment Date'
          },
          {
            key: 'invoice_reference',
            label: 'Invoice Reference'
          },
          {
            key: 'invoice_importer',
            label: 'Importer'
          },
          {
            key: 'value',
            label: 'Value'
          }
        ],
        settlements: [
          {
            key: 'settlement_date',
            label: 'Settlement Date'
          },
          {
            key: 'reference',
            label: 'Invoice Reference'
          },
          {
            key: 'importer',
            label: 'Importer'
          },
          {
            key: 'settlement_date',
            label: 'Settlement Date'
          },
          {
            key: 'settlement_customer_bank',
            label: 'Remittance Bank'
          },
          {
            key: 'value',
            label: 'Value'
          },
          {
            key: 'action',
            label: 'Actions'
          }
        ]
      },
      transactionFilters: [
        {
          text: 'Advances',
          value: 'advances'
        },
        {
          text: 'Payments',
          value: 'payments'
        },
        {
          text: 'Settlements',
          value: 'settlements'
        }
      ],
      transactionAmount: {
        recieved: 'Received',
        at: 'at',
        per: 'per'
      }
    }
  },
  holidays: {
    index: {
      title: 'Resources',
      list: 'Bank Holiday List'
    }
  },
  chargesCalculator: {
    index: {
      title: 'Resources',
      list: 'Charges Calculator',
      desc: 'INDIA BANK HOLIDAY LIST',
      caption:
        'Our partner banks will be closed on these days. All advances, settlements, and bank cover letter applications will be processed on the next working day.',
      invoiceDetails: {
        title: 'INVOICE DETAILS',
        headers: {
          particulars: 'PARTICULARS',
          value: 'VALUE'
        },
        fieldItems: {
          value: 'Invoice Face Value (A)',
          advanceTotal: 'Advance Total (B)',
          disbursedDate: 'Disbursed Date',
          dueDate: 'Due Date',
          receivedDate: 'Received Date',
          receivedAmount: 'Received Amount (Expected) (C)'
        }
      },
      calcDetailsTable: {
        title: 'CALCULATIONS DETAILS',
        headers: {
          particulars: 'PARTICULARS',
          expected: 'EXPECTED ON DUE DATE',
          asOn: 'AS ON'
        },
        firstRow: {
          firstColumn: 'This is the calculated charges as per the due date',
          secondColumn:
            'These are the charges on your invoice based on Drip receiving the payment on selected date'
        },
        duration: 'Duration',
        stepUpDbrDuration: 'Step-up DBR days',
        stepUpDbrRate: 'Step-up DBR Rate applied',
        overdue: 'Overdue Days',
        factoringRate: 'Discount Rate',
        factoringFees: 'Factoring Commission Fee (D)',
        advanceDuration: 'Duration',
        advanceRegularInterest: 'Discount Amount',
        regularInterest: 'Total Discount Amount (E)',
        overdueInterest: 'Overdue Fee (F)',
        otherCharges: 'Other charges (K)',
        stepUpDbrInterest: 'Step-up DBR Amount (F1)',
        totalFees: 'Total Charges (H=D+E+F+K+F1)',
        totalFeesWithoutDBR: 'Total Charges (H=D+E+F+K)',
        collectionAmount: 'Collection Amount',
        settlementBalance: 'Settlement Balance',
        settlementAdjusts: 'Settlement Adjusts',
        totalSettlement: 'Total Settlement'
      },
      selectInvoice: {
        label: 'SELECT AN INVOICE',
        placeHolder: 'SELECT AN INVOICE',
        text: 'Select an Invoice to calculate the charges',
        noResults: "We couldn't find any invoices with "
      }
    }
  },
  masterBl: {
    heading:
      'The shipping lines listed here are approved by Drip to be considered as Master BL',
    searchLine: 'Search shipping line',
    inputPlaceholder: 'Enter Shipping Line',
    sortBy: {
      heading: 'Sort By',
      atoz: 'A to Z',
      ztoa: 'Z to A'
    },
    sorry: {
      heading: 'Sorry, we couldn’t find any results for',
      line1: 'Can’t find what you’re looking for?',
      line2: 'Contact your Account Manager or write to us at',
      email: 'dripassist@dripcapital.com'
    }
  },
  buyers: {
    index: {
      htmlTitle: 'Buyers | Drip Portal',
      title: 'Buyers',
      limits: 'Limits',
      placeHolder: 'Search for a buyer',
      notFound: 'No buyer found',
      increaseLimit: 'Increase Limit',
      buyerFilters: [
        {
          text: 'All',
          value: 'All'
        },
        {
          text: 'Funding Available',
          value: 'Funding Available'
        },
        {
          text: 'Processing',
          value: 'Processing'
        },
        {
          text: 'On Hold',
          value: 'On Hold'
        },
        {
          text: 'Rejected',
          value: 'Rejected'
        }
      ],
      directTicket: {
        Processing: {
          Action: 'Expedite',
          questionType: 'Buyer related',
          question: 'Buyer application status follow-up'
        },
        Pending: {
          Action: 'Activate',
          questionType: 'Buyer related',
          question: 'Buyer resubmission/reapplication'
        },
        'Setoff Only': {
          Action: 'Activate',
          questionType: 'Buyer related',
          question: 'Buyer un-suspension / re-activation'
        },
        Active: {
          Action: 'Enhance buyer limit',
          questionType: 'Buyer related',
          question: 'Buyer limit increase'
        },
        Approved: {
          Action: 'Initiate notification',
          questionType: 'Buyer related',
          question: 'Initiate buyer notification'
        },
        Rejected: {
          Action: ''
        }
      },
      buyerFields: [
        {
          key: 'importer',
          label: 'Name',
          class: 'cell-border',
          sortable: true
        },
        {
          key: 'new_portal_status',
          label: 'Status',
          class: 'status-cell',
          sortable: true
        },
        {
          key: 'product_based_limit',
          label: 'Available Limit',
          sortable: true
        },
        {
          key: 'balance',
          label: 'Outstanding Balance',
          sortable: true
        },
        {
          key: 'invoices_total',
          label: 'Invoices Funded',
          sortable: true
        },
        {
          key: 'invoice_acknowledgement_required?',
          label: 'Confirmation Required?',
          sortable: true
        },
        {
          key: 'full_recourse_label?',
          label: 'Recourse Type',
          sortable: true
        },
        {
          key: 'action',
          class: 'no-wrap',
          label: 'Actions',
          sortable: true
        }
      ],
      fullRecourse: 'Full Recourse',
      limitedRecourse: 'Limited Recourse',
      acknowledgement: {
        yes: 'Yes',
        no: 'No'
      },
      status: {
        Processing: 'Processing',
        'On Hold': 'On Hold',
        Rejected: 'Rejected',
        'Funding Available': 'Fundable'
      }
    },
    modal: {
      paragraph:
        'You are submitting an invoice for a buyer that is not active. Advance for this invoice will only be processed if and when the buyer becomes active again.',
      cancel: 'Cancel',
      okay: 'OK, Got It'
    },
    single: {
      title: 'Account details',
      summary: {
        fields: {
          details: 'Buyer Details',
          name: 'Buyer Name',
          status: 'Buyer Status',
          productLimit: 'You can receive finance upto',
          product_based_limit: 'Available Limit',
          balance: 'Current Outstanding'
        }
      },
      pricing: {
        title: 'Pricing Details',
        banner: 'The updated terms are applicable as of',
        fields: {
          advanceRate: 'Advance rate',
          invoiceValue: 'of Net Invoice Value',
          factoringComission: 'Factoring commission fee',
          interestRate: 'Discount Rate',
          calculation: 'Calculated Daily'
        }
      },
      banking: {
        title: 'Drip Capital Bank details',
        desc: 'Please refer the below section for Drip Bank Instructions to be placed on the invoice',
        fields: {
          bankName: 'Bank Name',
          bankAddress: 'Bank Address',
          aba: 'ABA Routing',
          accName: 'Account Name',
          accNo: 'Account Number',
          swift: 'Swift'
        }
      },
      product: {
        title: 'Product Details',
        fields: {
          product: 'Product',
          paymentTenor: 'Maximum tenor',
          currency: 'Currency',
          cheque: 'Cheque type'
        }
      },
      buyer: {
        plan: {
          ofNetInvoiceValue: 'of net invoice value',
          upto: 'Upto',
          days: 'days:',
          pa: 'p.a.',
          progressLabel: 'Used facility limit',
          totalLimitLabel: 'Total facility limit'
        },
        product: {
          daysFrom: 'days from'
        }
      }
    },
    add: {
      htmlTitle: 'Add Buyer | Drip Portal',
      title: 'Add Buyer',
      form: {
        name: 'Buyer name',
        country: 'Buyer country',
        address: 'Buyer address',
        paymentTerms: 'Payment Terms',
        shipmentTerms: 'Shipment Terms',
        pastSales: 'Sales in the last 12 months (₹ Lakhs)',
        futureSales: 'Sales in next 12 months (₹ Lakhs)',
        creditPeriod: 'Payment Tenor',
        creditFrom: 'Credit From',
        experience: 'Years of relationship',
        currency: 'Currency',
        routing: 'Document routing',
        release: 'Document release',
        paymentTenor: 'Payment Tenor',
        daysFrom: 'Days From',
        drip_limit: 'Limit Required',
        relatedParty: 'Is the party related?',
        writeOffs: 'Write-off exist?',
        submit: 'Submit Buyer',
        next: 'Next Step',
        back: 'Back',
        helpText: {
          uploads: {
            'sample-po': {
              title: 'Attach PO from previous order',
              desc: "PO should be on buyer's letterhead to verify submitted details"
            },
            'sample-ci': {
              title: 'Attach invoice from previous order',
              desc: 'Invoice should contain all payment terms to verify submitted details'
            }
          },
          country: {
            title: 'Select buyer country',
            desc: 'Buyer should be a registered entity in this country'
          },
          name: {
            title: 'Exact buyer name',
            desc: 'Input exactly as mentioned on PO/invoice'
          },
          address: {
            title: 'Exact buyer address',
            desc: 'Input exact street address with zipcode'
          },
          routing: {
            title: 'How do you send documents to your client?',
            desc: 'Documents like original BLs, original invoice etc.'
          },
          release: {
            title: 'When do you release documents?',
            desc: 'Documents like original BLs, original invoice etc'
          },
          paymentTenor: {
            title: 'When does the buyer pay you?',
            desc: "Select buyer's payment deadline, in days, from selected date"
          },
          drip_limit: {
            title: 'What is the Buyer level limit required',
            desc: 'Using value of invoices at peak open orders, calculate required buyer limit'
          },
          years_selling: {
            title: 'Relationship with buyer',
            desc: 'Years of working with same buyer, under same of different buyer name'
          }
        },
        others: 'Others, please specify',
        required: 'This field is required',
        removeFile: 'Remove File'
      },
      progressSteps: [
        {
          step: '01',
          text: 'Uploads'
        },
        {
          step: '02',
          text: 'Buyer Information'
        },
        {
          step: '03',
          text: 'Operations'
        }
      ],
      business: {
        title: 'Add Business Relationship'
      },
      information: {
        title: 'Buyer Information'
      }
    },
    buyerFilters: [
      {
        key: 'Funding Available',
        label: 'Funding Available'
      },
      {
        key: 'Processing',
        label: 'Processing'
      },
      {
        key: 'On Hold',
        label: 'On Hold'
      },
      {
        key: 'Rejected',
        label: 'Rejected'
      }
    ]
  },
  dummyInvoice: {
    title: 'COMMERCIAL INVOICE',
    clipboard: 'Copied to Clipboard!',
    buttons: {
      accept: 'Accept',
      previous: 'Back',
      next: 'Next',
      stop: 'Got It'
    }
  },
  bankDetails: {
    bankName: 'Bank Name: ',
    bankAddress: 'Bank Address: ',
    swift: 'Swift Code (If Needed): ',
    abaRouting: 'ABA Routing & Transit No: ',
    accName: 'Account Name (For Credit To): ',
    accNumber: 'Account No: ',
    bankSort: 'Bank Sort Code: ',
    iban: 'Iban ',
    benName: 'Beneficiary Name (For Credit To): ',
    benAddress: 'Beneficiary Bank Address: ',
    benSwift: 'Beneficiary Swift Code: ',
    benAccount: 'Beneficiary Account Name: ',
    benAccNum: 'Beneficiary Account Number: '
  },
  invoices: {
    add: {
      htmlTitle: 'Add Invoice | Drip Portal',
      title: 'Add Invoice',
      titles: {
        invoiceInfo: 'Invoice Info',
        shippingDetails: 'Shipping Details',
        fundingInfo: 'Funding Info',
        uploadDocs: 'Upload Docs',
        review: 'Review & Submit'
      },
      subTitle: {
        fundingInfo:
          'Buyer bank details are required for bank-to-bank invoices in order to generate cover letters.',
        review: 'Please review below information'
      },
      form: {
        buyer: 'Buyer',
        currency: 'Invoice Currency',
        reference: 'Invoice Number',
        grossValue: 'Gross Value',
        advanceReceived: 'Advance Received',
        value: 'Net Invoice Value',
        maxAmount: 'Maximum Financeable Amount',
        invoiceDate: 'Invoice Date',
        userDueDate: 'Estimated Due Date',
        shippingBillDate: 'Shipping Bill Date',
        shippingBillNumber: 'Shipping Bill No.',
        blNo: 'BL Number',
        blDate: 'BL Date',
        container: 'Container Number',
        shippingLine: 'Shipping Line',
        consignee: 'Consignee',
        vesselName: 'Vessel Name',
        clientBankDetailId: 'Disbursement Bank',
        fundingType: 'Funding Type',
        fundingTypes: {
          adjustExisting: 'Adjust Against Existing',
          fundNew: 'Fund New Invoice'
        },
        customerNotes: 'Additional Notes, If Any',
        submit: 'Save & Proceed',
        invoiceReason: {
          funding: 'Fund New Invoice',
          adjustment: 'Adjust Against Existing'
        },
        adjustedInvoices: 'Invoices To Be Adjusted, If Any',
        response: {
          invoiceExists: 'This invoice already exists'
        },
        seller: 'Seller',
        remittance: {
          heading: 'Remittance Currency',
          chipText: 'INR Payments',
          enabled: 'Enabled',
          disabled: 'Disabled',
          transactionAmount: 'Transaction Amount',
          liveConversionRate: 'Live Conversion Rate',
          addedFees: 'Added Fees',
          receiveINR: 'You will receive INR',
          info: 'Conversion rates will vary based on the time of actual payment release.',
          enabledText: 'INR Remittances Enabled',
          disabledText: 'Enable INR remittances for this invoice',
          toggleOn: 'ON',
          toggleOff: 'OFF',
          infoTextDisabled:
            'You will receive your advanced and settlement payments for this invoice in USD.',
          infoTextEnabled:
            'You will receive your advanced and settlement payments for this invoice in INR.',
          newUserBanner: {
            title: 'Save more through payments in INR!',
            subtitle: 'And secure your eBRC hassle free!',
            inrButton: 'Get INR payments',
            denyButton: 'Not interested'
          }
        }
      },
      helpers: {
        buyer: {
          label: 'Buyer',
          placeHolder: 'Select Buyer',
          notFound: 'No elements found. Consider changing the search query.'
        },
        invoiceNo: {
          label: 'Invoice Number',
          placeHolder:
            'Enter invoice reference number you can use to track in future'
        },
        invoiceDate: {
          label: 'Invoice Date',
          placeHolder: 'Date of invoice'
        },
        currency: {
          label: 'Currency',
          placeHolder: 'Select Currency'
        },
        grossValue: {
          label: 'Gross Value',
          placeHolder: 'Enter Amount'
        },
        advanceReceived: {
          label: 'Advance Received From Buyer',
          placeHolder: 'Enter Amount'
        },
        netValue: {
          label: 'Net Invoice Value'
        },
        maxValue: {
          label: 'Maximum Financeable Amount',
          note: 'Actual amount may be lesser subject to availability of limits and other factors'
        },
        shippingBillDate: {
          label: 'Shipping Bill Date',
          placeHolder: 'Select Shipping Bill Date'
        },
        shippingLine: {
          label: 'Shipping Line',
          placeHolder: 'Enter Shipping Line'
        },
        consignee: {
          label: 'Consignee',
          placeHolder: 'Enter Consignee'
        },
        customerBuyerName: {
          label: 'Buyer Name',
          placeHolder: 'Enter buyer name'
        },
        vesselName: {
          label: 'Vessel Name',
          placeHolder: 'Enter Vessel Name'
        },
        userDueDate: {
          label: 'Estimated Due Date',
          placeHolder: 'Select Due Date'
        },
        containerNo: {
          label: 'Container Number',
          placeHolder: 'Enter Container Number'
        },
        blNo: {
          label: 'BL Number',
          placeHolder: 'Enter BL Number'
        },
        blDate: {
          label: 'BL Date',
          placeHolder: 'Select BL Date'
        },
        fundingType: {
          label: 'Funding Type'
        },
        clientBankDetailId: {
          title: 'Disbursement Bank',
          label: 'Select a disbursement bank'
        },
        customerNotes: {
          label: 'Additional Notes, If Any',
          placeHolder:
            "Provide additional details about your invoice for Drip's Operations Team."
        },
        adjustedInvoices: {
          label: 'Invoices To Be Adjusted, If Any',
          placeHolder: 'Select Invoices'
        },
        dropFileHere: ' Drop File Here',
        uploadFile: 'Upload File',
        uploadFiles: 'Upload File(s)',
        uploadFinancial: 'Upload Financials',
        addFile: 'Add more',
        fileLimitErr: 'Size limit of 50MB reached',
        uploadMsg:
          'Once you click on the submit button you can’t reupload the documents, for reuploading contact your Account Manager',
        fileTypeError: `You can't upload files of this type.`,
        pdfTypeOnly: 'Unsupported file type. You can upload PDF files',
        pdfAndImagesOnly:
          'Unsupported file type. You can upload PDF and image files',
        fileSizeError: 'You cannot add more files',
        fileSizeAvailableError:
          'Cannot add file, the available size for file upload is',
        discrepantInvoice: {
          title: 'Dissimilarity found in {docName}, Please reupload',
          commentLabel: 'Comments',
          modal: {
            title: 'Document Upload Success!',
            desc: `Due to dissimilarity found in the invoice, please expect a slight delay in invoice processing.`,
            ok: 'Ok, got it'
          }
        }
      },
      actions: {
        next: 'Next',
        save: 'Save as Draft',
        back: 'Back'
      },
      progressSteps: [
        {
          step: '1',
          text: 'Invoice Info'
        },
        {
          step: '2',
          text: 'Shipping Details'
        },
        {
          step: '3',
          text: 'Funding Info'
        },
        {
          step: '4',
          text: 'Upload Docs'
        },
        {
          step: '5',
          text: 'Review and submit'
        }
      ],
      step: 'Step',
      of: 'Of'
    },
    upload: {
      subtitle: 'Add Invoice Documents',
      addInvoice: 'Do you want to add another Invoice?',
      saveUpload: 'Yes, Save & Upload Another Invoice',
      noSaveProceedEsign: 'No, Save & Proceed with E-Sign',
      noSaveProceed: 'No, Save & Proceed',
      proceed:
        'As part of invoice submission, upload all documents, and then proceed to e-sign. Wish to add another invoice instead? Do so and come back later to complete the documentation process. Then, head to e-sign.',
      uploadLater: 'Yes, upload later',
      continue: 'Continue uploading',
      fileUpload: {
        upload: 'Upload',
        remove: 'Remove File',
        select: 'Click here to select file or drag and drop document here',
        size: '*Max File Size: 50MB',
        formatMsg: 'Please upload multiple documents in PDF format'
      },
      continueToEsign: 'Continue to E-Sign',
      esign: 'E-Sign',
      pleaseEsign: 'Please upload all documents to E-Sign',
      addMoreInvoices: 'Add more invoices',
      toDashBoard: 'Continue To Dashboard',
      commercial_invoice_title:
        'Please mandatorily include the following text in your invoice:',
      commercial_invoice_sub_text:
        'This invoice has been sold and assigned to Drip Capital Inc, 555 Bryant St #356 Palo Alto, CA 94301 USA. Please make all remittances towards this invoice directly to their bank account.',
      copy_text: 'Copy Text'
    },
    single: {
      printSave: 'Print / Save',
      failedToLoad: 'Failed to load invoice details',
      info: {
        title: 'Invoice Info',
        reference: 'Reference',
        seller: 'Seller',
        buyer: 'Buyer',
        invoiceValue: 'Invoice Value',
        containerNumber: 'Container Number',
        blDate: 'BL Date',
        paymentTerms: 'Payment Terms',
        dueDate: 'Due Date',
        poNo: 'PO No.',
        poDate: 'PO Date'
      },
      infoV2: {
        invoiceInformation: '1. Invoice Information',
        shippingDetails: '2. Shipping Details',
        fundingInformation: '3. Funding Information'
      },
      disbursements: {
        title: 'Disbursements',
        advance: 'Advance #',
        total: 'Total',
        totalAdvanced: 'Total Advanced'
      },
      payments: {
        title: 'Payments',
        payment: 'Payment #',
        total: 'Total',
        totalPayments: 'Total Payments'
      },
      statement: {
        title: 'Charges Calculations',
        netValue: 'Net Invoice Value',
        setOffAgainst: 'Set Off Against',
        setOffFrom: 'Set Off From',
        refNo: 'Ref No',
        date: 'Date',
        transactionType: 'Transaction Type',
        credit: 'Credit',
        debit: 'Debit',
        outstanding: 'Outstanding Balance',
        expectedChargesAsOn: 'Expected Charges as on',
        viewDetails: 'View Details',
        closeDetails: 'Close Details',
        today: 'Today',
        totalAmount: 'Total Amount',
        remittanceBank: 'Remittance Bank',
        payeeMemo: 'Payee Memo',
        viewCopy: 'View Swift Copy',
        forInvoices: 'For Invoices',
        chooseDate: 'Choose a Different Date'
      },
      outstanding: {
        title: 'Outstanding as on',
        today: 'Today',
        amount: 'Amount Outstanding',
        expectedTotal: 'Expected Total Charges',
        viewDetails: 'View Details',
        expectedSettlement: 'Expected Settlement Amount',
        expectedSettlementHint:
          'Amount Outstanding - Disbursements - Expected Total Charges',
        expectedTaxCalculation: 'Expected Tax Calculation',
        taxCalculation: 'Tax Calculation',
        isr: 'ISR',
        fourPercentOfTotalCharges: '4% of total charges'
      },
      settlement: {
        title: 'Settlement',
        total: 'Total Charges',
        amount: 'Settlement Amount',
        amountHint: 'Payments - Disbursements - Total Charges',
        date: 'Settlement Date',
        bank: 'Settlement Bank',
        viewDetails: 'View Details'
      },
      updates: {
        title: 'Invoice Updates',
        on: 'on',
        added_basic_invoice_details: 'Added Basic Invoice Details',
        bill_of_lading_uploaded: 'Bill of Lading Uploaded',
        commercial_invoice_uploaded: 'Commercial Invoice Uploaded',
        shipping_bill_uploaded: 'Shipping Bill Uploaded',
        purchase_orders_uploaded: 'Purchase Order(s) Uploaded',
        packing_list_uploaded: 'Packing List Uploaded',
        pdc_received: 'PDC Received',
        bl_received: 'BL Received',
        documents_generated_for_esign: 'Documents Generated for E-Sign',
        e_signed_by: 'E-Signed by ',
        invoice_processing_done: 'Invoice Processing Done',
        invoice_verified: 'Invoice Verified',
        invoice_advanced: 'Invoice Advanced',
        buyer_remittance_expected: 'Buyer Remittance Expected',
        buyer_payment_received: 'Buyer Payment Received',
        invoice_settled: 'Invoice Settled',
        physical_bl_returned: 'Physical BL Returned',
        pdc_returned: 'PDC Returned',
        invoice_data_verified: 'Invoice Data Verified'
      },
      uploadDocs: {
        commercial_invoice: 'Commercial Invoice',
        upload_file: 'Upload file',
        bill_s_of_lading: 'Bill(s) of Lading',
        purchase_order_s: 'Purchase Order(s)',
        shipping_bill_s: 'Shipping Bill(s)',
        shipping_bill_s_optional: 'Shipping Bill(s) (Optional)',
        bill_of_exchange_signable: 'Bill of Exchange (Signable)',
        bank_cover_letter: 'Bank Cover Letter',
        packing_list: 'Packing List',
        exporter_documents_checklist: 'Exporter Documents Checklist',
        additional_documents: 'Additional Documents',
        po: 'Purchase Order(s)',
        invoice: 'Commercial Invoice',
        bl: 'Bill(s) of Lading',
        prl: 'Purchase Request Letter',
        'packing-list': 'Packing List',
        boe: 'Bill of Exchange',
        'unsigned-boe': 'Bill of Exchange (Signable)',
        sb: 'Shipping Bill(s)',
        'sb-in': 'Shipping Bill(s)',
        'sb-pdmt': 'Shipping Bill(s)',
        coo: 'COO',
        mi: 'Marine Insurance',
        ic: 'Inspection Certificate',
        pdc: 'PDC',
        bld: 'BL Delivery Letter',
        'liner-noc': 'Liner NOC Letter',
        'remitter-note': "Remitter's Note",
        'bank-cover': 'Bank Cover Letter',
        'exp-checklist': 'Exporter Documents Checklist',
        supporting: 'Supporting Document',
        attachment: 'Attachment',
        additional: 'Additional Documents',
        'invoice-ack': 'Invoice Acknowledgement'
      },
      documents: {
        title: 'Documents',
        pending: 'Pending Documents',
        uploaded: 'Uploaded Documents',
        date: 'Uploaded on'
      },
      modals: {
        charges: {
          title: 'Total Charges Breakup',
          expected: 'Expected',
          factoringFee: 'Factoring Fee',
          percentOn: '% on',
          invoiceValue: '(Invoice Value)',
          interest: 'Interest',
          pa: '% P.A.',
          on: 'on',
          totalAdvanceFor: '(Total Advance) for',
          invoiceValueFor: '(Invoice Value) for',
          days: 'days',
          regularInterest: 'Regular Interest on',
          totalAdvance: 'Total Advance',
          advance: 'Advance #',
          for: 'for',
          overdueInterest: 'Overdue Interest on Total Advance',
          otherFees: 'Other Fees',
          processingFee: 'Processing Fee',
          docFees: 'Doc Fees',
          adjustments: 'Adjustments',
          totalCharges: 'Total Charges'
        }
      },
      charges: {
        expected: 'Expected Interest',
        interest: 'Interest',
        info: '{rate}% ({compound}) on {value} for {duration} days '
      },
      tabs: {
        submitted: 'Submitted Details',
        details: 'Details',
        documents: 'Documents',
        summary: 'Summary',
        statement: 'Statement'
      },
      downloadInvoice: 'Download Advice',

      noUpdates: 'No Updates'
    },
    index: {
      title: 'Invoices',
      esignInvoices: 'E-Sign Invoices',
      addInvoice: 'Add Invoice',
      pending: 'Pending Advance',
      outstanding: 'Advanced',
      received: 'Pending Settlement',
      settled: 'Settled',
      searchResults: 'Search results for',
      searchInvoice: 'Search for an invoice...',
      noInvoices:
        'No invoices found for the current filters. Please change filters or try different search terms.',
      view: 'View →',
      edit: 'Edit →',
      inrAdvice: {
        advanced:
          'Currency settings cannot be changed for invoices which are advanced.',
        settled:
          'Currency settings cannot be changed for invoices that have been settled.',
        paid: 'Currency settings cannot be changed for invoices that have been paid.'
      },
      disabledINRAdvice:
        'Currency settings cannot be changed for invoices which are advanced.',
      outstandingFields: [
        {
          key: 'reference',
          label: 'Reference',
          sortable: true
        },
        {
          key: 'importer',
          label: 'Importer',
          sortable: true
        },
        {
          key: 'value',
          label: 'Invoice Value',
          sortable: true
        },
        {
          key: 'advanced_date',
          label: 'Advanced Date',
          sortable: true
        },
        {
          key: 'total_advanced',
          label: 'Total Advanced',
          sortable: true
        },
        {
          key: 'payment_total',
          label: 'Payments Received',
          sortable: true
        },
        {
          key: 'outstanding',
          label: 'Outstanding From Buyer',
          sortable: true
        },
        {
          key: 'advice_exporter_fees',
          label: 'Expected Charges',
          sortable: true
        },
        {
          key: 'repayment',
          label: 'Due Date',
          sortable: true
        },
        {
          key: 'stage_human',
          label: 'Status'
        },
        {
          key: 'actions',
          label: 'Actions'
        }
      ],
      settledFields: [
        {
          key: 'reference',
          label: 'Reference',
          sortable: true
        },
        {
          key: 'importer',
          label: 'Importer',
          sortable: true
        },
        {
          key: 'value',
          label: 'Invoice Value',
          sortable: true
        },
        {
          key: 'advanced_date',
          label: 'Advanced Date',
          sortable: true
        },
        {
          key: 'total_advanced',
          label: 'Total Advanced',
          sortable: true
        },
        {
          key: 'received_amount',
          label: 'Received Amount',
          sortable: true
        },
        {
          key: 'exporter_fees',
          label: 'Charges',
          sortable: true
        },
        {
          key: 'settlement',
          label: 'Settlement Amt',
          sortable: true
        },
        {
          key: 'settlement_date',
          label: 'Settlement Date',
          sortable: true
        },
        {
          key: 'actions',
          label: 'Actions'
        }
      ],
      receivedFields: [
        {
          key: 'reference',
          label: 'Reference',
          sortable: true
        },
        {
          key: 'importer',
          label: 'Importer',
          sortable: true
        },
        {
          key: 'value',
          label: 'Invoice Value',
          sortable: true
        },
        {
          key: 'advanced_date',
          label: 'Advanced Date',
          sortable: true
        },
        {
          key: 'total_advanced',
          label: 'Total Advanced',
          sortable: true
        },
        {
          key: 'received_amount',
          label: 'Received Amount',
          sortable: true
        },
        {
          key: 'exporter_fees',
          label: 'Expected Charges',
          sortable: true
        },
        {
          key: 'settlement',
          label: 'Expected Settlement Amt',
          sortable: true
        },
        {
          key: 'actions',
          label: 'Actions'
        }
      ],
      pendingFields: [
        {
          key: 'reference',
          label: 'Reference',
          sortable: true
        },
        {
          key: 'importer',
          label: 'Importer',
          sortable: true
        },
        {
          key: 'value',
          label: 'Invoice Value',
          sortable: true
        },
        {
          key: 'stage_human',
          label: 'Status'
        },
        {
          key: 'actions',
          label: 'Actions'
        }
      ],
      require: {
        text: 'Showing invoices that require {filter}',
        information: 'critical information',
        documents: 'critical documents',
        esign: 'e-signature'
      },
      exportData: {
        title: 'Export Data',
        exportInvoicesData: 'Export Invoices Data',
        export: 'Export',
        required: 'This field is required',
        labels: {
          from: 'From',
          to: 'To'
        },
        error: 'Date fields are mandatory',
        errorFailed: 'Download PDF of invoice list failed'
      },
      downloadInvoice: 'Download Advice',
      editDraft: 'Edit Draft',
      viewInvoice: 'View Invoice',
      only: 'Only',
      notFound: 'No Invoices Found'
    },
    warnings: {
      // todo: rethink organization when we add more warnings.
      late: {
        title: 'Note',
        text: 'Invoices received after 8PM IST will be processed on the next working day.',
        dismiss: 'Click here to dismiss.'
      }
    },
    tracking: {
      title: 'Containers Tracking',
      container: {
        showMore: 'Show More',
        fetch: 'Fetching Container Data',
        noData: 'No Data Available',
        delayed: 'Shipment Delayed'
      },
      modal: {
        title: 'Container Tracking - {containerNumber}'
      },
      dhlNumber: 'DHL Tracking Number'
    },
    esign: {
      title: 'Following Invoices Can Be Esigned:',
      noDocs: "We couldn't find any invoices that require an E-Signature.",
      esignNow: 'E-Sign Now',
      toolTip: 'You are not authorized to Esign',
      nps: {
        modalTitle:
          'How likely would you recommend Drip to your friends and relatives?',
        label1: 'Not at all likely',
        label2: 'Extremely likely',
        pageNumber1: '1 of 2',
        pageNumber2: '2 of 2',
        btnNext: 'Next',
        btnSubmit: 'Submit',
        ques1:
          'What would Drip Capital have to do to earn higher recommendation?',
        ques2:
          'What does Drip Capital do particularly well to earn your recommendation?',
        thanks: 'Thank You!',
        feedback: 'Feedback Successfully Submitted',
        closeModal: 'X',
        placeholder: 'Write your recommendation here...',
        wnr: 'Would not Recommend',
        mr: 'Might Recommend',
        dr: 'Definitely Recommend'
      },
      viewAll: 'View All Invoices',
      fields: [
        {
          key: 'reference',
          label: 'Reference'
        },
        {
          key: 'importer',
          label: 'Importer'
        },
        {
          key: 'value',
          label: 'Invoice Value'
        }
      ]
    },
    requestQuery: {
      helpText: 'Need help?',
      requestText: 'Raise Request',
      modal: {
        subject: 'Subject*',
        subjectPlaceholder: 'Choose a Subject',
        description: 'Describe (optional)',
        successTitle: 'Request Sent',
        successMessage:
          'Thank you for submitting this request. You will receive an email shortly acknowledging your request and a link where you can follow the status of your ticket.'
      }
    }
  },
  account: {
    index: {
      htmlTitle: 'Account | Drip Capital',
      title: 'Account',
      accountInfoTab: 'Account Details',
      currencySettingsTab: 'Currency Settings',
      summary: {
        title: 'Summary',
        fields: {
          limit: 'Total facility limit',
          fee: 'Establishment fee',
          ofCreditLimit: 'of total facility limit'
        }
      },
      pricing: {
        title: 'Pricing Details',
        fields: {
          advanceRate: 'Advance rate',
          factoringComission: 'Factoring commission fee',
          interestRate: 'Discount rate',
          ofNetInvoiceValue: 'of net invoice value',
          days: 'days:',
          pa: 'p.a.',
          upto: 'Upto',
          dbr: 'Current Drip Base Rate (DBR)',
          dbrAsOf: 'Drip Base Rate (DBR) as of ',
          dbrPrevRate: '(previously ',
          spreadValue: 'Spread Value'
        }
      },
      product: {
        title: 'Product Specifics',
        fields: {
          paymentTenor: 'Maximum tenor',
          docFee: 'Document Handling Fee',
          currency: 'Currency',
          cheque: 'Cheque type',
          daysFrom: 'days from'
        }
      },
      currencySettings: {
        heading: 'Currency Settings',
        benefits: {
          pageHeading: 'Benefits of Drip Switch',
          forex: 'Best Forex Rates ',
          wireFees: 'No International Wire Fees',
          RtgsPayments: 'Receive RTGS payments',
          hassleFree: 'Hassle-free eRBC Process'
        },
        paymentEnabledBanner: {
          title: 'Invoice currency settings',
          chip: 'INR Payments Enabled',
          button: 'Disable INR payments',
          content:
            "With Drip capital's best exchange rate, you will now be maximising your savings by receiving payments on your submitted invoices in INR. This will also give you a hassle-free eBRC process.",
          dialog: {
            heading: 'We are sorry to let you go!',
            body: 'You will now stop receiving INR payments from Drip Capital. \n You can still opt-in for INR payments while submitting an invoice.',
            alternateBody:
              'You will now stop receiving INR payments for this invoice from Drip Capital. \n You can still opt-in for INR payments while submitting an invoice.'
          }
        },
        invoiceSettingTable: {
          title: 'Currency setting for your invoices',
          subtitle:
            'You can set your currency preference on selected invoices.',
          inrPayments: 'INR Payments',
          advAmount: {
            prepend: 'You received',
            at: ' at '
          },
          multipleAdvs: 'Multiple Advances. Click for details.'
        },
        faq: {
          pageHeading: 'Frequently Asked Questions',
          close: 'Close',
          questions: [
            {
              heading:
                'Will this work only with USD? Can I get EUR and GBP payments in INR too?',
              body: 'For now, Drip Switch will only be applicable to USD payments. This will also be done only for Drip financed transactions.'
            },
            {
              heading:
                'Will I be able to view and book rates for each transaction?',
              body: 'You can view the live rate on your Drip portal at any time. The rate that will apply to your remittances will be based on the actual time of disbursement. You will not be able to confirm the rate at a transactional level. However, Drip will keep the spread constant so you will receive the same marginal benefit compared to your bank as you receive for the first transaction.'
            },
            {
              heading:
                'Will there be any bank charges or deductions in the remittance received?',
              body: 'There may be a nominal $10-15 incoming wire fee similar to what your bank currently charges.'
            },
            {
              heading:
                'Will this help reduce my interest rate or the cost of financing?',
              body: 'Your cost of financing will remain unchanged. However, this product helps you save on fx conversion which can help offset your cost of financing.'
            },
            {
              heading:
                'If you will disburse funds in INR, will this be eligible for any interest subvention schemes?',
              body: 'No, you will not be eligible for any interest subvention offered by RBI for INR borrowing. Since the source of funds is in foreign currency and your credit facility is set up in USD, this cannot be considered as INR borrowing.'
            },
            {
              heading:
                'Can I avail of Drip Switch for revenue not financed via Drip?',
              body: 'Not at the moment. We may need to collect additional documentation for transactions not financed via Drip. This is in our roadmap and on the cards for June 2023.. You will need to ask your buyers to make payments for even unfinanced transactions directly to Drip. We will forward these in full to you in INR after collecting your invoice documents.'
            },
            {
              heading:
                'Is this permitted by RBI? Will I face challenges with closing my eBRC?',
              body: 'RBI permits Indian companies to receive export proceeds in INR as long as the fx is converted on Indian shores. In this case, we will be remitting USD to our partner Indian bank so this process is compliant with RBI guidelines. Your AD bank is required to close the eBRC as long as they receive the details of the foreign currency remittance received in an Indian bank. The eFIRC/eFIRA issued to you is sufficient documentation to close your eBRC.'
            },
            {
              heading:
                'I have already hedged my fx with my bank for the next few months. How can I use this product?',
              body: 'You can consume your hedged position for fx proceeds that are not financed via Drip and use Drip Switch for transactions financed via Drip. If you have taken a position for your complete projected throughput, you can come back to us once your hedged period is over.'
            },
            {
              heading:
                'I have a packing credit / working capital facility with my bank in USD which I need to close in USD. Is the product still relevant for me?',
              body: 'Frankly, no. It is more economically efficient for you to receive your funds in USD.'
            }
          ],
          widget: {
            title: 'Have more questions?',
            button: 'View FAQs'
          }
        }
      },
      accountDataUpdates: 'Account Data Updates',
      accountDataSubtitle:
        'Data updates for your account helps us manage risk effectively and also benefits you, allowing us to offer timely services like credit limit increases when needed.',
      financialStatementsTitle1: 'Financial Statements ',
      financialStatementsTitle2: '(from {startDate} to {endDate})',
      onlyPdfMessage:
        'Only PDF files allowed and file size should not exceed 50 MB.',
      accountDataNote:
        'Note: Please be assured that your privacy is a top priority – we never store your user credentials. ',
      gstTitle: 'GST Verification',
      gstLastSuccessful: 'Last Successful Update: {lastUpdated}',
      updateNow: 'Update now',
      accountDataRequired: 'Account Data Update Required!',
      accountDataRequiredSubtitle:
        'Please update the required data by {blockDate} to avoid revoking invoice upload access.',

      gstInfo:
        'Your company GST needs to be updated every 6 months. If you have multiple GSTs, please verify all.',
      howToVerifyGst: 'How to verify GST?',
      verifyGst: 'Verify GST?',
      uploadFinancial: 'Upload Financial Statements',
      noteSize: 'Note: File size should not be more than 50 MB.',
      submitFiles: 'Submit File(s)',
      invoiceBlockText:
        'Your invoice flow has been blocked. Please update the data below to submit an invoice.',
      PageGettingUpdated: 'Your account page is getting updated.',
      stayTuned: 'Stay tuned!'
    }
  },
  alerts: {
    dashboard: {
      basicInfo:
        '1 invoice is missing critical information. | {count} invoices are missing critical information.',
      basicInfoCta: 'View Invoice | View Invoices',
      docsPending:
        '1 invoice is missing critical documents. | {count} invoices are missing critical documents.',
      docsPendingCta: 'View Invoice | View Invoices',
      esignPending:
        '1 invoice has documents that need an E-Signature. | {count} invoices have documents that need an E-Signature.',
      esignPendingCta: 'Esign Documents'
    },
    invoiceList: {
      docsPending: {
        title: 'Documents Pending',
        message:
          '1 invoice is missing critical documents. | {count} invoices are missing critical documents.',
        cta: 'View Invoice | View Invoices'
      },
      basicInfoPending: {
        title: 'Basic Info Pending',
        message:
          '1 invoice is missing critical information. | {count} invoices are missing critical information.',
        cta: 'View Invoice | View Invoices'
      },
      esignPending: {
        title: 'ESign Pending',
        message:
          '1 invoice has documents that need an E-Signature. | {count} invoices have documents that need an E-Signature.',
        cta: 'Esign Documents'
      }
    },
    invoice: {
      docsPending: 'This invoice is missing critical documents',
      docsPendingCta: 'Upload Documents',
      esignPending: 'This invoice has documents that need an E-Signature.',
      esignPendingCta: 'Esign Documents',
      esignRequired: 'E-Sign Required!',
      docsRequired: 'Documents Required!'
    }
  },
  chat: {
    inputPlaceholder: 'Start typing...'
  },
  importers: {
    invoices: {
      title: 'Invoices',
      pending: 'Pending Advance',
      outstanding: 'Advanced',
      received: 'Pending Settlement',
      settled: 'Settled',
      searchResults: 'Search results for',
      noInvoices:
        'No invoices found for the current filters. Please change filters or try different search terms.',
      searchInvoice: 'Search for an invoice...',
      invoiceTableFields: [
        {
          key: 'exporter',
          label: 'Exporter'
        },
        {
          class: 'po-col',
          key: 'po_no',
          label: 'Purchase Order #'
        },
        {
          key: 'reference',
          label: 'Invoice Reference'
        },
        {
          key: 'invoice_date',
          label: 'Invoice Date'
        },
        {
          key: 'payment_total',
          label: 'Payments'
        },
        {
          key: 'advice_collection_pending',
          label: 'Net Payable Amount'
        },
        {
          key: 'repayment',
          label: 'Due Date'
        },
        {
          key: 'documents_public',
          label: 'Actions'
        }
      ]
    },
    index: {
      noDocs: "We couldn't find any documents that require an E-Signature.",
      ack: {
        toBeEsigned: 'Following Invoices Have Acknowledgements To Be E-Signed:',
        esignNow: 'E-Sign Now'
      },
      boe: {
        toBeEsigned: 'Following Invoices Have BOEs To Be E-Signed:',
        esignNow: 'E-Sign Now'
      },
      invoicesListTable: [
        {
          key: 'selected',
          label: ''
        },
        {
          key: 'exporter',
          label: 'Exporter'
        },
        {
          class: 'po-col',
          key: 'po_no',
          label: 'Purchase Order #'
        },
        {
          key: 'reference',
          label: 'Invoice Reference'
        },
        {
          key: 'invoice_date',
          label: 'Invoice Date'
        },
        {
          key: 'importer',
          label: 'Importer'
        },
        {
          key: 'value',
          label: 'Net Payable Amount'
        },
        {
          key: 'repayment',
          label: 'Due Date'
        },
        {
          key: 'documents_public',
          label: 'Actions'
        }
      ]
    }
  },
  common: {
    invoiceAdvice: 'Invoice Advice',
    invoiceSwift: 'Transaction Copy',
    invoiceNoc: 'NOC Document',
    downloads: 'Downloads',
    print: {
      to: 'To,',
      local: 'For correspondence in India'
    },
    alert: {
      viewInvoices: 'View Invoices'
    },
    address: {
      us: {
        company: 'Drip Capital Inc.',
        line1: '555 Bryant St. #356,',
        line2: 'Palo Alto, CA 94301'
      },
      local: {
        company: 'Drip Capital Services India LLP',
        line1: '1001, Embassy Chambers,',
        line2: 'Khar West, Mumbai 400052, India'
      },
      website: 'https://www.dripcapital.com'
    }
  },
  login: {
    emailLogin: 'Login with email',
    phoneLogin: 'Login with phone number',
    login: 'Login',
    emailForm: {
      email: 'Email',
      password: 'Password',
      forgotPassword: 'Forgot your password?'
    },
    phoneForm: {
      phone: 'Phone Number',
      getOtp: 'Get OTP',
      otp: 'OTP'
    },
    sendResetLink: 'Send Reset Link',
    backToLogin: 'Back to Login',
    emailSent:
      'We have sent you an email. Please check your inbox for further instructions.',
    newPass: 'New Password',
    confirmPass: 'Confirm Password',
    resetPass: 'Reset password'
  },
  newLogin: {
    heading: 'Log in',
    emailSubHeading: 'Please sign in to your account below using your email.',
    phoneSubHeading:
      'Please sign in to your account below using your phone number.',
    emailForm: {
      emailLabel: 'Email Address',
      emailPlaceholder: 'Example@gmail.com',
      passwordLabel: 'Password',
      passwordPlaceholder: 'Enter your password',
      checkbox: 'Remember me',
      forgotPassword: 'Forgot Password?',
      loginButton: 'Login',
      link1: "Don't have an account? Sign up",
      or: 'or',
      link2: "Don't remember your email ID",
      phoneLogin: 'Log in with phone number'
    },
    phoneForm: {
      phoneLabel: 'Phone number',
      placeholder: 'Eg: 9892350750',
      getOtp: 'Get verification code',
      link1: "Don't have an account? Sign up",
      or: 'or',
      link2: "Don't remember your phone number?",
      emailLogin: 'Log in with email',
      enterOtp: 'Enter verification code',
      otpMsg:
        'We have sent a verification code to your phone number “{phone}”. Please enter verification code to verify and log in.',
      numberChange: 'Phone number not correct? change phone number',
      verify: 'Verify and Login',
      link3: "Didn't receive verification code?",
      resendOtp: 'Resend verification code',
      link4: "Don't have an account? Sign up",
      info: "Don't remember your phone number?"
    },
    success: {
      text: 'Your email is verified',
      description:
        'We have verified your email you can sign in now with your set password'
    },
    error: {
      linkText: 'Forgot Password?',
      text: '<p class="mb-0"><strong>Sorry we’re not able to get you logged in</strong></p>',
      description:
        'We are not able to match the user name and password. Do you want to reset your password?'
    },
    phoneError: {
      text: `<p class="mb-0"><strong>Account not available</strong>`,
      description: `We are not able to find an account associated with the <span class="error-email">"{phone}"</span>. Please contact our customer support team to add your number to an account.</p>`
    },
    otpError: {
      text: 'Verification code is invalid',
      description:
        'Try again with a valid verification code sent to you on your phone number'
    },
    registration: {
      text: 'Your account registration was successful',
      description: 'Please login with your set credentials'
    },
    resetPassword: {
      text: 'Your password reset was successful',
      description: 'Please login with your set credentials'
    }
  },
  newResetPassword: {
    heading: 'Reset Password',
    subHeading: 'Please enter a desired password',
    email: 'Email',
    resetForm: {
      passwordLabel: 'Create Password',
      confirmLabel: 'Confirm Password',
      resetButton: 'Reset Password',
      or: 'or',
      link1: 'Change your email or phone number ?',
      info: 'Please contact our customer care services. They will help you to update your email and phone number.'
    },
    success: {
      text: 'Verification email is successfully sent',
      description:
        'We have verified your email you can sign in now with your set password'
    },
    error: {
      text: '<p class="mb-0"><strong>We were not able to find your account</strong> We are not able to find an account associated with the <strong>“{email}”</strong></p>'
    },
    validations: {
      minMax: 'Contains 8-14 characters',
      upperCase: 'One upper case character',
      splChar: 'One special character',
      oneDigit: 'One number'
    }
  },
  newForgotPassword: {
    heading: 'Forgot Password',
    subHeading: 'Please enter your email to reset your password',
    or: 'Or',
    loginLink: 'Back to sign in',
    forgotForm: {
      emailLabel: 'Email Address',
      emailPlaceholder: 'Example@gmail.com',
      resetButton: 'Send reset link',
      or: 'or',
      link1: 'Change your email or phone number ?',
      info: 'If you want to change your email or phone number, please contact our customer care services.'
    },
    success: {
      text: 'Verification email sent',
      description:
        'We have verified your email you can sign in now with your set password'
    },
    error: {
      text: `<p class="mb-0"><strong>Account not found</strong>`,
      description: `We are not able to find an account associated with the <span class="error-email">"{email}"</span>. Please contact our customer support team.</p>`
    }
  },
  confirmEmail: {
    heading: 'Confirm your email',
    link1_1: 'Check your inbox at ',
    link1_email: 'steve.jennings@gmail.com',
    link1_2: 'and click on the link to reset your password.',
    link2_question: 'Incorrect Email?',
    link2_link: 'Change email',
    info: "If you haven't received an email, please check your spam or promotions folder or resend email.",
    resend: 'Resend email',
    link3_question: 'Already verified the email?',
    link3_link: 'Login',
    msg: 'Verification email is successfully sent to the mentioned email address'
  },
  notifications: {
    title: 'Important Message',
    login: {
      title: 'Error',
      text: 'Invalid credentials.'
    },
    esign: {
      title: 'E-sign Successful',
      text: 'We will review your documents and release the funds once completed.'
    },
    importers: {
      title: 'Success',
      text: 'The Esign process was completed successfully.'
    },
    somethingWrong: {
      title: 'Error',
      text: 'Something went wrong. We are looking into it.'
    },
    buyerAdded: {
      title: 'Success',
      text: 'Buyer addition requested successfully.'
    },
    passwordError: {
      title: 'Error!',
      text: 'Something went wrong. Please get in touch with us at cs@dripcapital.com for assistance.'
    },
    resetPassword: {
      title: 'Success',
      text: 'Your password has been reset.'
    },
    copyMsg: 'Copied to clipboard!',
    otp: {
      title: 'Verification code',
      text: 'Verification code sent successfully'
    }
  },
  public: {
    invoices: {
      unauthorized: 'You are not authorized to view this document.'
    }
  },
  passbook: {
    title: 'Welcome to Passbook',
    subtitle: 'View and Manage all your transactions here',
    lead: 'Begin by selecting all your parameters you want to view',
    invoiceNumber: 'Invoice Number',
    noData: 'No Data',
    openingBalance: 'Opening Balance',
    closingBalance: 'Closing Balance',
    download: 'Download as Excel',
    placeHolder: 'Search for a reference number or a buyer…',
    sidebar: {
      labels: {
        view: 'View',
        date: 'Date',
        from: 'From',
        to: 'To',
        currency: 'Currency',
        transactionType: 'Transaction Type',
        buyers: 'Buyers',
        apply: 'Apply'
      },
      options: {
        views: [
          // { text: 'Bank Transactions', value: 'transactions' },
          { text: 'Statement', value: 'statement' }
        ],
        dates: [
          { text: 'This Month', value: 'current' },
          { text: 'Last Month', value: 'last' },
          { text: 'Date Range', value: 'range' }
        ],
        transactionTypes: [
          { text: 'Advance', value: 'advance' },
          { text: 'Payment', value: 'payment' },
          { text: 'Settlement', value: 'settlement' },
          { text: 'Charges', value: 'charges' }
        ],
        buyers: [{ value: '', text: 'All Buyers' }]
      }
    }
  },
  invoiceFilters: {
    pending: 'Pending',
    processing: 'Processing',
    approved: 'Approved',
    advanced: 'Advanced',
    paid: 'Paid',
    settled: 'Settled'
  },
  invoiceSettingsTableFields: [
    {
      key: 'reference',
      label: 'Invoice Number',
      class: 'reference-cell pl-1 pl-md-3',
      sortable: true
    },
    {
      key: 'importer',
      label: 'Buyer',
      class: 'buyer-cell',
      sortable: true
    },
    {
      key: 'value',
      label: 'Net Invoice Value',
      sortable: true
    },
    {
      key: 'total_advanced',
      label: 'Advance Amount'
    },
    {
      key: 'stage_human',
      label: 'Status',
      class: 'status-cell'
    },
    {
      key: 'drip_switch_enabled',
      label: 'INR Payments'
    }
  ],
  invoiceTableFields: [
    {
      key: 'reference',
      label: 'Invoice number',
      class: 'reference-cell pl-1 pl-md-3',
      sortable: true
    },
    {
      key: 'importer',
      label: 'Buyer',
      class: 'buyer-cell',
      sortable: true
    },
    {
      key: 'value',
      label: 'Net Invoice',
      sortable: true
    },
    {
      key: 'advanced_date',
      label: 'Advanced Date'
    },
    {
      key: 'total_advanced',
      label: 'Advance Amount'
    },
    {
      key: 'charges',
      label: 'Charges'
    },
    {
      key: 'repayment',
      label: 'Due Date'
    },
    {
      key: 'stage_human',
      label: 'Status',
      class: 'status-cell'
    },
    {
      key: 'drip_switch_enabled',
      label: 'INR Payments'
    },
    {
      key: 'action',
      label: 'Actions'
    }
  ],
  invoiceTableItems: {
    inrPayments: 'INR Payments',
    expected: 'Expected',
    charged: 'Charged',
    status: {
      'Exporter E-Sign Pending': 'Esign Required',
      'Exporter E-Sign Generated': 'Esign Required',
      'Invoice Processing': 'Processing',
      'Docs Pending': 'Docs Pending',
      'Basic Info Pending': 'Basic Info Pending',
      Hold: 'Hold',
      Pending: 'Pending',
      Processing: 'Processing',
      Approved: 'Approved',
      Advanced: 'Advanced',
      Paid: 'Paid',
      Settled: 'Settled',
      'Buyer E-Sign Pending': 'Buyer E-Sign Pending',
      'Partial Advanced': 'Partial Advanced',
      'Partial Payment': 'Partial Payment',
      'Pending Settlement': 'Pending Settlement',
      Draft: 'Draft',
      'Auto Advanced': 'Auto Advanced',
      NPA: 'NPA',
      'Collection Only': 'Collection Only',
      Claim: 'Claim',
      Outdated: 'Outdated',
      'Auto Settled': 'Auto Settled',
      Overdue: 'Overdue',
      'Follow Up': 'Follow Up',
      'ETD Check': 'ETD Check',
      'FDA Check': 'FDA Check',
      'Due in 15 Days': 'Due in 15 Days',
      'Due in 5 Days': 'Due in 5 Days',
      'Due in 1 Day': 'Due in 1 Day',
      'GUD Check': 'GUD Check',
      'Deposit Added': 'Deposit Added',
      'Physical Docs Pending': 'Physical Docs Pending',
      Revised: 'Revised',
      'Revision Pending': 'Revision Pending',
      'Review and Submit': 'Review Pending',
      'E-Sign Pending': 'E-Sign Pending'
    }
  },
  searchForm: {
    placeholder: 'Search for an Invoice'
  },
  cmaList: {
    DATA_KEYS: {
      PERSON: 'person',
      MOBILE: 'mobile',
      EMAIL: 'email',
      COMPANY: 'company',
      ADDRESS: 'address'
    },
    index: {
      title: 'Resources',
      list: 'CMA List',
      desc: 'We have partnered with Team Global, Seashell Logistics & Aagaaz Worldtrade to collect BL’s on our behalf.'
    }
  },
  multiselect: {
    selectLabel: 'Press enter to select',
    deSelectLabel: 'Press enter to remove',
    selectedLabel: 'Selected'
  },
  networkErrList: {
    title: 'Error',
    defaultMsg: 'Something went wrong, Please try again later',
    400: 'Bad Request',
    401: 'Unauthorized',
    402: 'Payment Required',
    403: 'Forbidden',
    404: 'Not Found',
    405: 'Method Not Allowed',
    406: 'Not Acceptable',
    407: 'Proxy Authentication Required',
    408: 'Request Timeout',
    409: 'Conflict',
    410: 'Gone',
    411: 'Length Required',
    412: 'Precondition Failed',
    413: 'Payload Too Large',
    414: 'URI Too Long',
    415: 'Unsupported Media Type',
    416: 'Range Not Satisfiable',
    417: 'Expectation Failed',
    418: 'I am a teapot',
    421: 'Misdirected Request',
    422: 'Unprocessable Entity',
    423: 'Locked',
    424: 'Failed Dependency',
    425: 'Too Early',
    426: 'Upgrade Required',
    428: 'Precondition Required',
    429: 'Too Many Requests',
    431: 'Request Header Fields Too Large',
    451: 'Unavailable For Legal Reasons',
    500: 'Internal Server Error',
    501: 'Not Implemented',
    502: 'Bad Gateway',
    503: 'Service Unavailable',
    504: 'Gateway Timeout',
    505: 'HTTP Version Not Supported',
    506: 'Variant Also Negotiates',
    507: 'Insufficient Storage',
    508: 'Loop Detected',
    510: 'Not Extended',
    511: 'Network Authentication Required'
  },
  bankAccounts: {
    title: 'Bank Accounts',
    desc: 'Below is the list of banks you have added',
    addBankBtn: 'Add Bank Account',
    addBankDisabledText: 'You are not authorised to proceed',
    addBankBtnDisabled: 'You do not have permission to add a bank.',
    verified: 'Verified',
    verificationPending: 'Verification pending',
    view: 'View',
    beneficiaryBankDetails: 'Beneficiary bank details',
    archivedTitle: 'Archived bank accounts(Not in use)',
    archivedDesc: 'Their are no archived bank accounts',
    archived: 'Archived',
    archivalPending: 'Archival Pending',
    archiveAccount: 'Archive account',
    accountNumber: 'Account Number',
    beneficiaryName: 'Beneficiary Name',
    bankName: 'Bank Name',
    bankCity: 'Bank City',
    ifscCode: 'IFSC code',
    swiftCode: 'Swift Code',
    fedwireABA: 'FEDWIRE ABA',
    accountType: 'Bank Account Type',
    cancelledCheque: 'Cancelled cheque',
    download: 'Download',
    eefcLetter: 'EEFC Letter',
    correspondentBankDetails: 'Correspondent bank details',
    currency: 'Currency',
    archivalConsent: {
      title: 'Are you sure you want to archive this bank information?',
      desc: 'Once you archive the account your not able to use this bank account for you future bank payments',
      action: {
        yes: 'Yes, Archive',
        no: 'No, dont archive'
      }
    },
    archivalSuccess: {
      msg: `We've recorded your request to archive this bank information. We will send you a confirmation once it's approved from our systems`,
      action: {
        gotIt: 'Got it'
      }
    }
  },
  pdc: {
    title: 'Post dated cheque details',
    desc: 'Enter these details on a cheque while sending PDC to the drip capital.',
    pay: 'Pay',
    learnMore: 'Learn More',
    payDesc: `This is the entity you're making the cheque for, in this case Drip Capital Services`,
    payValue: 'DRIP CAPITAL SERVICES INDIA LLP',
    invAmtLabel: 'Invoice amount in numbers',
    invAmtWordsLabel: 'Invoice amount in words',
    date: 'Date',
    dateDesc: `Date on the post dated cheque is calculated as per Drip Capital's policies`,
    sampleCheque: 'Sample cheque'
  },
  coverLetter: {
    title: 'Cover letter instructions',
    why: 'why?',
    subTitle:
      'Why buyer bank details are required for cover letter instructions?',
    desc: 'Buyer bank details are required for bank-to-bank invoices',
    selectTitle: 'Select buyer bank',
    selectDesc: 'There are no buyer bank details added for buyer name {name}',
    fields: {
      bankAddress: 'Bank Address',
      swift: 'Swift',
      pinCode: 'PIN code',
      contactName: 'Contact Name At Buyer Bank',
      contactPhone: 'Contact Number At Buyer Bank'
    },
    addBuyerLabel: 'Add buyer bank details',
    add: 'Add',
    successMsg: 'Successfully added buyer bank',
    inputLabels: {
      bankName: 'Buyer Bank Name',
      bankAddress: 'Buyer Bank Address',
      swift: 'Swift',
      pinCode: 'PIN Code',
      contactName: 'Contact Name At Buyer Bank',
      contactNumber: 'Contact Number At Buyer Bank',
      addBank: 'Add bank',
      save: 'Save',
      cancel: 'Cancel',
      optional: 'Optional'
    },
    placeholders: {
      bankName: 'Enter Buyer Bank Name',
      bankAddress: 'Enter Buyer Bank Address',
      swift: 'Enter Swift',
      pinCode: 'Enter PIN Code',
      contactName: 'Enter Contact Name',
      contactNumber: 'Enter Contact Number'
    },
    error: {
      addBank: 'Please add buyer bank details for cover letter instructions',
      selectBank: 'Please select a buyer bank for cover letter instructions'
    },
    seeAll: 'See all',
    modal: {
      prependTitle: 'Do you want to delete',
      appendTitle: 'from the list?',
      subtitle: 'You can add the buyer bank details later.',
      deleteButton: 'Yes, Delete',
      cancelButton: 'Cancel'
    }
  },
  invoiceStage: {
    discrepant: 'Revision pending',
    revised: 'Processing'
  },
  addBank: {
    title: 'Add Bank Account',
    accountType: 'Select Bank Account Type',
    current: 'Current Bank Account',
    eefc: 'EEFC Bank Account',
    beneficiary: 'Beneficiary Bank Details',
    cancelledCheque: 'Upload Cancelled Cheque',
    correspondentBank: 'Correspondent Bank Details',
    correspondentTitle: 'What is correspondent bank details',
    correspondentSubtitle:
      'A correspondent bank is a financial institution authorised to provide services on behalf of another financial institution. You can find you correspondent bank details by searching corresponding bank for the bank name entered and currency of transaction',
    learnMore: 'learn more',
    beneficiaryLabel: 'Beneficiary Name',
    beneficiaryPlaceholder: 'Enter beneficiary name',
    bankLabel: 'Bank Name',
    bankPlaceholder: 'Enter bank name',
    accountLabel: 'Account Number',
    accountPlaceholder: 'Enter account number',
    corrAccountLabel: 'Account Number (Optional)',
    corrAccountPlaceholder: 'Enter account number',
    confirmationLabel: 'Confirm Account Number',
    cityLabel: 'Bank City',
    cityPlaceholder: 'Enter bank city',
    swiftLabel: 'Swift Code',
    swiftPlaceholder: 'Enter swift code',
    fedwireAbaLabel: 'FEDWIRE ABA (Optional)',
    fedwireAbaPlaceholder: 'Enter FEDWIRE ABA',
    ifscLabel: 'IFSC Code (Optional)',
    ifscPlaceholder: 'Enter IFSC code',
    uploadEefc: 'Upload EEFC letter',
    eefcTitle: 'How to get EEFC letter',
    eefcSubtitle:
      "For Drip Capital to verify and consider this bank information submitted, as a valid proof of your EEFC account, please download and print the below document on your bank's letterhead and upload it as a proof of your bank account information",
    eefcLetter: 'EEFC bank letter',
    uploadEefcLetter: 'Please upload EEFC letter',
    downloadFormat: 'To Download the EEFC bank Letter format',
    clickHere: 'click here',
    modalSuccess: 'Got it',
    modalMsg:
      'Successfully added the bank information. It will get verified in next 2 or 3 business days.',
    addBankButton: 'Add Bank',
    cancelButton: 'Cancel',
    currency: 'Currency',
    currencySelect: 'Select Currency',
    upload: 'Upload',
    cheque: 'Cancelled Cheque',
    uploadCheque: 'Please upload cancelled bank cheque related to your bank.',
    notAdded: 'Bank account is not added',
    notSupported:
      'The invoice currency selected is not supported by existing bank accounts',
    cancelMsg: 'Are you sure you want to cancel?',
    confirm: 'Confirm',
    requiredDocs: 'Please upload the required document',
    validationError: 'Bank Account Confirmation Number does not match',
    validationSuccess: 'Bank Account Number Confirmed!'
  },
  clickWrap: {
    heading1: 'Invoice Documents dated',
    heading2:
      'Please read the document(s) carefully and scroll to the bottom to accept and E-sign.',
    consentTitle:
      'Please provide your consent by clicking on the check box. You can only E-sign after clicking on the checkbox.',
    consentText:
      'I have read and understood the document and agree to the information contained therein. By typing my name into the box, I attest that I am the person authenticated into this request or an authorized signatory for the Client, and the data/information I am entering/verifying is accurate and true to the best of my knowledge.',
    inputLabel: 'Signature',
    inputButton: 'Complete E-sign',
    scrollToBottom: 'Scroll to bottom',
    validations: {
      required: 'Your name is required',
      alpha: 'Please remove any special characters (.,/,<,>,*, %)'
    },
    esignPostLoading: 'Processing your E-sign',
    esignDocumentIdMissing: 'Document could not be fetched!',
    esignFailedAlert: {
      title: 'E-sign Successful',
      text: 'Failed to sign document'
    },
    esignNotFoundAlert: {
      title: 'E-sign Failed',
      text: 'Something went wrong!'
    }
  },
  bank: {
    list: {
      page: 'Bank accounts',
      accounts: {
        editButton: 'View/Edit Details',
        viewButton: 'View Account'
      },
      addMoreBanks: {
        title: 'Add a new bank account',
        subtitle:
          'You can add new bank accounts and edit their details while they are under verification stage.',
        button: 'Add bank account'
      }
    },
    addBank: {
      header: 'Add bank account',
      headerUpdate: 'Edit bank account',
      title: 'Beneficiary Bank details',
      form: {
        title: "'s bank account details",
        subtext:
          'You can only edit your bank details when the bank is in verification pending.',
        beneficiary_name: {
          label: 'Beneficiary name',
          placeholder: 'e.g. ABC Supplier'
        },
        bank_name: {
          label: 'Beneficiary bank name',
          placeholder: 'e.g. ABC Bank'
        },
        bank_city: {
          label: 'Beneficiary bank city',
          placeholder: 'e.g. California'
        },
        beneficiary_account: {
          label: 'Beneficiary account number/IBAN',
          placeholder: 'e.g. 123456789'
        },
        swift_code: {
          label: 'SWIFT Code',
          placeholder: 'e.g. ABCDEFGHKLM',
          errorMessage: 'Minimum 8 and maximum 11 characters.'
        },
        currency: {
          label: 'Currency',
          placeholder: 'e.g. USD'
        },
        supporting_document: {
          header: 'Upload Supporting Document',
          title:
            'To confirm your account details, please upload any of the following:',
          subtitle:
            'Cancelled Cheque / EEFC Letter / First page of Passbook or Bank Statement',
          label: 'Supporting Document',
          subtext:
            'Please upload a supporting document to verify your bank details.',
          placeholder: 'e.g. USD'
        },
        correspondingDetails: {
          title: 'Correspondent Bank Details',
          subtext:
            'Note: As JP Morgan bank is our banking partner, kindly use any other bank as correspondent bank.'
        },
        cor_bank_name: {
          label: 'Correspondent bank name',
          placeholder: 'e.g. ABC Bank'
        },
        cor_bank_swift_code: {
          label: 'Correspondent bank SWIFT Code',
          placeholder: 'e.g. ABCDEFGHKLM'
        },
        uploads: {
          bank_supporting_document: {
            title: 'Supporting Document',
            subtext:
              'Please upload a supporting document to verify your bank details.',
            errorMessage: 'Supporting document(s) are required.'
          }
        },
        buttonUpdate: 'Update bank details',
        buttonAddBank: 'Complete Bank Addition'
      },
      successAddBank: 'Your bank has been added',
      successUpdateBank: 'Bank details updated successfully'
    },
    view: {
      subtext:
        "You can edit your supplier and supplier bank details while it's under verification. We will notify you once they are verified.",
      contact: {
        title: 'Supplier details'
      },
      company: {
        title: 'Beneficiary Bank details',
        name: 'Beneficiary Name',
        bank_name: 'Beneficiary Bank Name',
        bank_city: 'Beneficiary Bank City',
        account_number: 'Beneficiary Account Number/IBAN',
        swift_code: 'SWIFT Code',
        currency: 'Currency',
        documentsTitle: 'Upload Supporting Document',
        documentsSubtitle:
          'To confirm your account details, please upload any of the following: Cancelled Cheque / EEFC Letter / First page of Passbook or Bank Statement',
        corresponding_name: 'Correspondent Bank Name',
        corresponding_swift_code: 'Correspondent Bank SWIFT Code',
        pci: {
          title: 'Supporting Document',
          subtext:
            'Please upload a supporting document to verify your bank details.'
        },
        uploads: {
          downloadBtn: 'Download'
        }
      },
      bank: {
        title: 'Supplier bank details',
        accountNumber: 'Account number',
        abaRouting: 'ABA number',
        swift: 'SWIFT Code/ABA number',
        currency: 'Currency'
      }
    }
  },
  accountSummary: {
    back: 'Back',
    heading: 'Account Summary',
    title: 'Your Account Details',
    accountSummaryFields: [
      {
        key: 'accountName',
        label: 'Account name',
        class: 'reference-cell pl-1 pl-md-3',
        sortable: false
      },
      {
        key: 'totalFacility',
        label: 'Total Facility Limit',
        class: 'reference-cell pl-1 pl-md-3',
        sortable: false
      },
      {
        key: 'usedFacility',
        label: 'Used Facility Limit (as on current date)',
        class: 'reference-cell pl-1 pl-md-3',
        sortable: false
      }
    ],
    note: {
      title: 'Download account summary:',
      list_item_1:
        'The account summary will only include invoices which are advanced.',
      list_item_2:
        "Fees will be calculated as on current (today's) date for advanced and overdue invoices"
    },
    buyer: {
      title: 'Select a buyer:',
      label: 'Buyers'
    },
    date_range: {
      title: 'Select a date range:',
      option_1: 'Last 30 days',
      option_2: 'Last 3 months',
      option_3: 'Last financial year'
    },
    date: {
      or: 'Or',
      from: 'From',
      to: 'To',
      validation: "The 'From Date' must be earlier than the 'To Date'.",
      download_button: 'Download summary'
    }
  },
  error: {
    unableToProcess: 'Unable to process your request',
    unauthorizedToolTip: 'You are not authorized to proceed',
    unauthorizedPage: 'You are not authorized to access the page',
    unauthorizedAccess: 'You do not have the required permissions'
  },
  legal: {
    page1: {
      mainTitle: 'E-sign Legal Agreement',
      subtitle: 'The legal agreement contains the following documents:',
      documents: [
        'RPA',
        'Schedule I',
        `UDC Undertaking (Please keep your UDC's handy)`,
        'Appointment Agent',
        'LOA/Sole Proprietorship Letter'
      ],
      title: 'Select a date and city for your legal agreement:',
      date: {
        label: 'Date',
        placeholder: 'Select a date'
      },
      city: {
        label: 'City',
        placeholder: 'Enter your city'
      },
      button: 'Generate legal agreement',
      nonSignatoryMessage1: 'You are not authorised to E-sign.',
      nonSignatoryMessage2:
        'Please log-in from an authorised signatory account to proceed with E-sign.',
      mandatoryInformation: {
        title: 'Mandatory steps after E-sign:',
        subtext:
          'Kindly courier the original undated cheques to our Mumbai office as a mandatory verification step for invoice funding.'
      },
      companyInformation: {
        title: 'Drip Capital Services India LLP Mumbai',
        subtext:
          '1221, 2nd Floor, Building 12 Solitaire Corporate Park, Guru Hargovindji Rd, Chakala, Andheri East, Mumbai, Maharashtra 400093'
      },
      additionalContact:
        'If you have questions, please contact your sales manager {name} '
    },
    page2: {
      loaderText: 'Re-directing you to Drip Portal',
      mainTitle: 'Adobe E-sign',
      subtitle:
        "Kindly read through the legal agreement and follow Adobe's instructions to sign the same.",
      subtext:
        'If you have questions, please contact your sales manager {name}',
      button: 'Update date and city',
      download: 'Download agreement',
      esignSuccess: {
        title: 'E-sign successful!',
        message:
          "This screen will time-out in 10-15 seconds and you will be re-directed to Drip's portal.."
      }
    },
    banner: {
      title: 'Welcome to Drip Portal!',
      description:
        'Your e-signed legal agreement copy has been emailed to you.',
      stepTitle: 'Mandatory steps to get your invoice funded:',
      instruction:
        'Kindly courier the physical post dated/undated cheques to our Mumbai office for invoice funding.',
      clickHere: 'Click here',
      address: 'for complete address.',
      bottomText:
        'Please add a bank account and upload your invoice for underwriting.',
      note: 'Note: Till the time we do not receive your cheques, we cannot fund your invoices.',
      getStarted: 'Get started'
    }
  },
  remittances: {
    listRemittance: {
      title: 'Remittances',
      cardHeading: 'Add new remittance',
      cardHeading2: 'Add a new Remittance',
      cardTitle: 'Fill a simple form and add your remittance!',
      cardDesc:
        'You can add a new remittance for financed and un-financed invoices!',
      cardDesc2:
        'You can add remittances for financed and un-financed invoices. For any questions or concerns, reach out to your account manager!',
      cardButton: 'Add new remittance',
      cardButton2: 'Add a remittance',
      eventAdd: 'Add Remittance - Navigate to add remittance form',
      eventView: 'Add Remittance - Navigate to view remittance form',
      listCardStatus: {
        pending: 'Payment yet to be cited',
        partial: 'Partial Marked',
        marked: 'Remittance Marked'
      },
      listCardInvoiceSelected: 'Invoice(s) selected:',
      listCardRemittanceAmt: 'Remittance Amount:',
      listCardButton: 'View Remittance'
    },
    viewRemittance: {
      removeRemittance: 'Delete Remittance',
      buyerDetailsTitle: 'Buyer and Remitter Details',
      buyerDetails: [
        'Buyer',
        'Remitter/Consignee name',
        'Beneficiary Bank City'
      ],
      invoiceDetailsTitle: 'Invoice Details',
      invoiceDetails: ['Invoice(s)', 'Remittance amount', 'Invoice Currency'],
      unFinancedInvoiceTitle: 'Un-financed Invoice',
      unFinancedInvoice: ['Bank', 'Amount', 'Narration'],
      upload: {
        title: 'Upload Remittance',
        cardTitle: 'Remittance Copy/Document',
        cardSubtitle:
          'Only PDF and image files allowed. Each file size should not be more than 10 MB.',
        downloadButton: 'Download'
      },
      textInput: 'Additional instructions regarding the remittance',
      textPlaceholder: 'Provide specific details about this remittance',
      deleteSuccess: 'Remittance Deleted Successfully',
      deleteFailed: 'Failed to delete remittance!'
    },
    addRemittance: {
      breadcrumbMain: 'Remittances',
      breadcrumbText: 'Add a new remittance',
      heading: 'Add a remittance',
      inputs: [
        {
          heading: 'Buyer and Remitter Details',
          label: 'Buyers',
          placeHolder: 'Select a buyer'
        },
        {
          label: 'Remitter/Third Party/Consignee Name:',
          placeHolder: 'e.g. ABC Company ',
          checkboxText: 'Click here if the buyer and remitter is the same.'
        },
        {
          label: 'Remittance Currency',
          placeHolder: 'Select a currency'
        },
        {
          label: 'Remittance Amount',
          placeHolder: 'e.g. 45,900 '
        },
        {
          heading: 'Invoice details',
          subtext:
            'You can see invoices based on your buyer and the currency selected above.',
          label: 'Invoices',
          placeHolder: 'Select multiple invoices',
          error: 'This is invoice error'
        },
        {
          heading: 'Un-financed invoice',
          label: 'Select bank',
          placeHolder: 'Select a bank'
        },
        {
          label: 'Remittance Amount (Un-financed)',
          placeHolder: 'e.g. 45,900 '
        },
        {
          label: 'Narration',
          placeHolder: 'Enter your narration'
        },
        {
          label: 'Additional instructions regarding the remittance',
          placeHolder: 'Provide specific details about this remittance'
        }
      ],
      uploads: {
        title: 'Upload Remittance',
        cardTitle: 'Remittance Copy/Document',
        cardSubtitle:
          'Only PDF and image files allowed. Each file size should not be more than 10 MB.',
        errorMessage: 'Remittance Copy/document(s) are required.'
      },
      submitButton: 'Submit Remittance',
      submitSuccess: 'Remittance Added Successfully'
    }
  },
  digilocker: {
    verify: {
      error:
        'Your Digilocker link is no longer valid. Please generate a new link to continue.',
      heading: 'Drip Capital',
      body1:
        "As a part of Drip Capital's onboarding journey, you need to verify your Aadhaar details securely via DigiLocker, a government-approved digital document storage system.",
      body2:
        'To verify your identity, a one-time password (OTP) will be sent to your registered mobile number.',
      link: 'How to verify your Aadhar? Watch the video guide >',
      consent: {
        title: 'Please click on the checkbox below to start your KYC Process.',
        body: 'I hereby provide my consent to Drip Capital Services LLP to access my DigiLocker contact details and use it for financing purpose only.'
      },
      button: 'Start KYC'
    },
    status: {
      success: {
        heading: 'Thank you',
        title: 'KYC Process Successfully Completed',
        body: 'Thank you for completing the DigiLocker KYC. Our team will now review your details and update you shortly'
      },
      failed: {
        heading: 'KYC Unsuccessful',
        title: 'Unable to Complete Your KYC',
        body: 'Unfortunately, we were unable to complete your DigiLocker KYC. Please check your details and try again or contact our support team for assistance.'
      }
    }
  },
  // error messages
  messages: {
    required: (fieldName) => `${fieldName || 'The field'} is required.`,
    multiple_required: (fieldName) =>
      `Please select an option for ${fieldName || 'this field'}.`,
    select_required: 'Please select an option',
    alpha_num: 'This field may only contain alpha-numeric characters.',
    remove_specials: 'Please remove any special characters (.,/,<,>,*, %)',
    remove_specials_spaces:
      'Please remove any special characters (.,/,<,>,*, %) and spaces',
    remove_number: 'Please remove any numbers.',
    numbers_only: 'Only numbers allowed.',
    confirmed: 'The confirmation should match the password.',
    email: 'This field is not valid',
    min: (fieldName, length) =>
      `This field must be at least ${length} characters`,
    numeric: 'This field may only contain numeric characters'
  },
  custom: {
    advance_received: {
      max_value: 'Advance Received cannot be higher than invoice amount'
    },
    gross_value: {
      min_value: 'Gross value should be more than 0'
    }
  }
}
